var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoicingSendAlertSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 236,
    viewBox: "0 0 284 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_495_1942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3594 167.836H23.625V164.047H46.3594V167.836Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3579 167.836H25.6562L26.1352 164.047H46.3579V167.836Z",
    fill: "white",
    fillOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 235.821H3.9682L34.935 92.2729H30.9668L0 235.821Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12891 235.821H3.96779L34.9345 92.2729H32.0957L1.12891 235.821Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.442 235.654H52.4699L35.1406 92.2729H39.1088L56.442 235.654Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4415 235.654H53.6027L36.2695 92.2729H39.1084L56.4415 235.654Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8203 235.654H18.7924L32.4221 92.2729H28.4539L14.8203 235.654Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9492 235.654H18.792L32.4217 92.2729H29.5829L15.9492 235.654Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2625 81.12C57.2954 94.7419 54.11 110.373 43.1478 116.032C32.1855 121.69 17.5978 115.233 10.5649 101.611C3.53195 87.9894 6.71741 72.358 17.6757 66.6997C28.6379 61.0414 43.2256 67.498 50.2586 81.12H50.2625Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9343 80.2828C58.9673 93.9048 55.7818 109.536 44.8196 115.194C33.8574 120.853 19.2697 114.396 12.2368 100.774C5.20382 87.1522 8.38929 71.5209 19.3476 65.8626C30.3098 60.2043 44.8975 66.6609 51.9305 80.2828H51.9343Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9343 80.2828C58.9673 93.9048 55.7818 109.536 44.8196 115.194C33.8574 120.853 19.2697 114.396 12.2368 100.774C5.20382 87.1522 8.38929 71.5209 19.3476 65.8626C30.3098 60.2043 44.8975 66.6609 51.9305 80.2828H51.9343Z",
    fill: "white",
    fillOpacity: 0.701961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9342 80.2828C44.9012 66.6609 30.3135 60.2043 19.3513 65.8626C8.38911 71.5209 5.20364 87.1522 12.2366 100.778C19.2695 114.4 33.8572 120.857 44.8194 115.198C55.7817 109.54 58.9632 93.9087 51.9342 80.2828ZM43.9238 109.633C35.0761 114.201 23.3039 108.991 17.6262 97.9937C11.9523 87.0003 14.5225 74.3792 23.3662 69.8152C32.2139 65.2473 43.99 70.4577 49.6677 81.455C55.3416 92.4522 52.7714 105.069 43.9238 109.633Z",
    fill: "#3F7BFF",
    fillOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8268 82.4051C43.2784 73.6003 33.8505 69.4257 26.763 73.0823C19.6756 76.7429 17.6194 86.8445 22.1679 95.6493C26.7124 104.458 36.1442 108.633 43.2277 104.972C50.3113 101.315 52.3714 91.2099 47.8268 82.4051ZM42.2737 100.782C37.0476 103.481 29.9796 100.186 26.4865 93.4218C22.9934 86.6576 24.4031 78.986 29.6292 76.2873C34.8552 73.5886 41.9232 76.8831 45.4163 83.6473C48.9094 90.4077 47.4997 98.0793 42.2737 100.778V100.782Z",
    fill: "#3F7BFF",
    fillOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2647 79.8388C28.7015 81.6769 27.8331 87.0782 30.3215 91.9031C32.8099 96.7241 37.7166 99.1424 41.2798 97.3044C44.843 95.4663 45.7115 90.065 43.2231 85.244C40.7347 80.423 35.8279 78.0047 32.2647 79.8427V79.8388ZM40.6295 94.4499C38.2151 95.6961 34.7999 93.8813 33.0046 90.3999C31.2094 86.9146 31.7079 83.0827 34.1184 81.8366C36.5328 80.5904 39.948 82.4012 41.7433 85.8865C43.5424 89.368 43.0439 93.2038 40.6295 94.4499Z",
    fill: "#3F7BFF",
    fillOpacity: 0.701961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9859 84.3523C34.6579 85.0377 34.3815 87.1523 35.3706 89.0682C36.3597 90.988 38.2406 91.985 39.5724 91.2996C40.9004 90.6142 41.1769 88.4997 40.1877 86.5837C39.1986 84.6639 37.3177 83.6669 35.9859 84.3523Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2011 64.8459L63.7134 68.195L63.2305 74.562L68.7057 77.8604L75.1896 74.5114L69.6131 71.2714L70.2011 64.8459Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0067 88.3515C38.5161 88.4177 38.0137 88.1724 37.7723 87.709C37.4646 87.1171 37.6983 86.385 38.2941 86.0773L70.0514 69.6827C70.6433 69.375 71.3754 69.6087 71.6831 70.2045C71.9907 70.7964 71.7571 71.5285 71.1612 71.8362L39.404 88.2308C39.2755 88.297 39.143 88.336 39.0106 88.3554L39.0067 88.3515Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0067 88.3515C38.5161 88.4177 38.0137 88.1724 37.7723 87.709C37.4646 87.1171 37.6983 86.385 38.2941 86.0773L70.0514 69.6827C70.6433 69.375 71.3754 69.6087 71.6831 70.2045C71.9907 70.7964 71.7571 71.5285 71.1612 71.8362L39.404 88.2308C39.2755 88.297 39.143 88.336 39.0106 88.3554L39.0067 88.3515Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.083 217.168V218.55L261.865 220.455H257.083V223.718H261.203L265.557 226.565H262.293L266.643 229.092H262.293V235.576L185.324 235.607V231.985L182.431 229.092H185.967V220.996H179.658V218.278H176.516V217.168H257.083Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.083 217.168V218.55L261.865 220.455H257.083V223.718H261.203L265.557 226.565H262.293L266.643 229.092H262.293V235.576L185.324 235.607V231.985L182.431 229.092H185.967V220.996H179.658V218.278H176.516V217.168H257.083Z",
    fill: "white",
    fillOpacity: 0.701961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.082 217.168V218.55L261.864 220.455H257.082V223.718H261.202L265.556 226.565H262.292L266.642 229.092H262.292V235.576L220.391 235.607V231.985L217.497 229.092H221.033V220.996H214.725V218.278H211.582V217.168H257.082Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.965 220.996H221.032L221.188 223.445L185.965 220.996Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.66 218.278H214.728L179.66 219.501V218.278Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.965 229.092H221.032L185.965 227.799V229.092Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.324 231.985H220.392V233.325L185.324 231.985Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.084 218.55L221.035 218.278L257.084 217.46V218.55Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.082 220.455H220.391L257.082 221.678V220.455Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.292 226.565H221.578V227.799L262.292 226.565Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.292 229.092H232.789L262.292 229.906V229.092Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.286 199.021V200.403L269.068 202.308H264.286V205.575H268.406L272.76 208.422H269.497L273.846 210.949H269.497V217.433L192.527 217.464V213.842L189.634 210.949H193.17V202.853H186.861V200.135H183.719V199.021H264.286Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.286 199.021V200.403L269.068 202.308H264.286V205.575H268.406L272.76 208.422H269.497L273.846 210.949H269.497V217.433L192.527 217.464V213.842L189.634 210.949H193.17V202.853H186.861V200.135H183.719V199.021H264.286Z",
    fill: "white",
    fillOpacity: 0.701961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.285 199.021V200.403L269.067 202.308H264.285V205.575H268.405L272.759 208.422H269.496L273.845 210.949H269.496V217.433L227.594 217.464V213.842L224.7 210.949H228.236V202.853H221.928V200.135H218.785V199.021H264.285Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.168 202.853H228.235L228.391 205.302L193.168 202.853Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.863 200.135H221.931L186.863 201.358V200.135Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.168 210.949H228.235L193.168 209.652V210.949Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.527 213.842H227.595V215.182L192.527 213.842Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.287 200.403L228.238 200.135L264.287 199.317V200.403Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.285 202.308H227.594L264.285 203.534V202.308Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.495 208.422H228.781V209.652L269.495 208.422Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.495 210.949H239.992L269.495 211.763V210.949Z",
    fill: "black",
    fillOpacity: 0.101961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.386 182.592L271.852 225.354L277.471 226.211L284.002 183.452L278.386 182.592Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.386 182.592L271.852 225.354L277.471 226.211L284.002 183.452L278.386 182.592Z",
    fill: "white",
    fillOpacity: 0.701961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.246 184.223L282.18 184.667L283.78 184.908L283.85 184.464L282.246 184.223Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.051 185.508L281.98 185.948L283.585 186.193L283.651 185.749L282.051 185.508Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.855 186.793L281.789 187.237L283.39 187.482L283.46 187.035L281.855 186.793Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.66 188.078L281.59 188.522L283.194 188.767L283.26 188.323L281.66 188.078Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.461 189.363L281.395 189.807L282.995 190.053L283.065 189.609L281.461 189.363Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.265 190.648L281.199 191.092L282.8 191.338L282.866 190.894L281.265 190.648Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07 191.934L281 192.378L282.604 192.623L282.671 192.179L281.07 191.934Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.871 193.219L280.805 193.662L282.405 193.908L282.475 193.464L280.871 193.219Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.679 194.504L280.609 194.951L282.214 195.193L282.28 194.749L280.679 194.504Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.48 195.793L280.414 196.237L282.015 196.478L282.085 196.038L280.48 195.793Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.285 197.078L280.215 197.522L281.819 197.767L281.885 197.323L280.285 197.078Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.086 198.363L280.02 198.807L281.62 199.052L281.69 198.608L280.086 198.363Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.89 199.648L279.824 200.092L281.425 200.337L281.491 199.893L279.89 199.648Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.695 200.933L279.625 201.377L281.229 201.622L281.296 201.178L279.695 200.933Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.496 202.218L279.43 202.662L281.03 202.907L281.1 202.463L279.496 202.218Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.301 203.503L279.23 203.947L280.835 204.192L280.901 203.749L279.301 203.503Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.105 204.788L279.039 205.232L280.64 205.478L280.71 205.034L279.105 204.788Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.91 206.077L278.84 206.521L280.444 206.767L280.51 206.319L278.91 206.077Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.711 207.363L278.645 207.806L280.245 208.052L280.315 207.608L278.711 207.363Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.515 208.647L278.449 209.091L280.05 209.337L280.116 208.893L278.515 208.647Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.324 209.933L278.254 210.377L279.858 210.622L279.925 210.178L278.324 209.933Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.121 211.218L278.055 211.662L279.655 211.907L279.725 211.463L278.121 211.218Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.929 212.503L277.859 212.947L279.464 213.192L279.53 212.748L277.929 212.503Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.73 213.788L277.664 214.236L279.265 214.477L279.335 214.033L277.73 213.788Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.277 218.254H272.454V189.461H270.277V218.254Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.456 186.193H272.279L272.454 189.461H270.277L270.456 186.193Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.456 186.193H272.279L272.454 189.461H270.277L270.456 186.193Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.277 218.254H272.454V189.461H270.277V218.254Z",
    fill: "black",
    fillOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.864 221.6L264.76 221.358L261.072 192.475L259.176 192.716L262.864 221.6Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.215 190.364L258.772 189.71L258.651 185.82L259.847 185.672L261.35 192.413L261.248 193.865L259.352 194.107L259.083 193.343L259.496 198.46L259.255 198.492C258.476 195.345 258.215 190.364 258.215 190.364Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.215 190.364L258.772 189.71L258.651 185.82L259.847 185.672L261.35 192.413L261.248 193.865L259.352 194.107L259.083 193.343L259.496 198.46L259.255 198.492C258.476 195.345 258.215 190.364 258.215 190.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.438 199.438L268.388 199.753L268.17 193.775L263.283 193.518L262.438 199.438Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.436 199.438L268.387 199.753L267.004 215.91L262.117 215.653L262.436 199.438Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.191 207.658H282.264L280.488 235.821H261.967L260.191 207.658Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.875 209.465H282.578V206.595H259.875V209.465Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.875 209.465H282.578V206.595H259.875V209.465Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.945 2.90869H100.41C96.1299 2.90869 92.6602 6.37843 92.6602 10.6582V32.5592C92.6602 36.839 96.1299 40.3087 100.41 40.3087H114.242L122.696 48.4904L119.452 40.3087H122.945C127.225 40.3087 130.695 36.839 130.695 32.5592V10.6582C130.695 6.37843 127.225 2.90869 122.945 2.90869Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.945 2.90869H100.41C96.1299 2.90869 92.6602 6.37843 92.6602 10.6582V32.5592C92.6602 36.839 96.1299 40.3087 100.41 40.3087H114.242L122.696 48.4904L119.452 40.3087H122.945C127.225 40.3087 130.695 36.839 130.695 32.5592V10.6582C130.695 6.37843 127.225 2.90869 122.945 2.90869Z",
    fill: "white",
    fillOpacity: 0.701961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.849 17.2237C105.808 13.9526 109.64 15.152 111.646 17.6482C113.585 15.1013 117.39 13.8046 119.426 17.0251C122.865 22.4536 115.988 27.6134 112.732 29.6384C112.362 29.8721 112.058 30.0629 111.805 30.2148C111.548 30.0707 111.237 29.8877 110.863 29.6618C107.557 27.7186 100.547 22.7379 103.845 17.2237H103.849Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.192 36.243H256.395L245.401 27.9094L237.434 32.8006L247.192 36.243Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.192 36.243H256.395L245.401 27.9094L237.434 32.8006L247.192 36.243Z",
    fill: "black",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.645 0.178711H240.28L206.42 22.2861L215.755 25.6975L155.745 137.683L88.8306 145.008L34.0234 235.817H64.554H76.9922H107.523L135.877 172.416L197.744 165.55L246.632 32.8005L256.395 36.2508L248.645 0.178711Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.861 22.29L226.518 25.7014L177.042 137.679L110.817 145.012L64.554 235.821H34.0234L88.8344 145.012L155.745 137.679L215.758 25.7014L206.416 22.29L240.28 0.182605L248.645 0.178711L216.861 22.29Z",
    fill: "white",
    fillOpacity: 0.25098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.414 22.29H216.858L226.516 25.7014H215.756L206.414 22.29Z",
    fill: "#3F7BFF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.395 36.243L246.636 32.8005L197.748 165.55L135.877 172.416L107.523 235.821H64.5547L110.818 145.012L177.043 137.679L226.519 25.7014L216.861 22.2901L248.646 0.182617L256.395 36.243Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8359 145.012H110.819L177.044 137.679H155.746L88.8359 145.012Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.936 49.5575C143.936 49.5575 135.298 51.5435 134.788 57.9767C134.407 62.7666 137.362 70.555 135.466 80.7812C134.59 85.4932 134.633 95.5987 147.853 92.3198C163.769 88.375 160.981 52.8987 154.38 51.2047C147.779 49.5107 143.936 49.5536 143.936 49.5536V49.5575Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.701 77.2765C159.689 77.2765 159.677 77.2765 159.666 77.2726C159.572 77.2531 159.514 77.1636 159.533 77.0701C161.691 66.2364 158.622 54.1838 155.471 52.0615C154.918 51.6877 154.393 51.6565 153.914 51.9719C153.836 52.0226 153.731 52.0031 153.676 51.9213C153.626 51.8434 153.645 51.7383 153.727 51.6838C154.323 51.2943 154.992 51.3255 155.662 51.7772C158.871 53.9424 162.123 65.8081 159.868 77.1363C159.852 77.2181 159.782 77.2726 159.701 77.2726V77.2765Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.792 185.769L179.135 184.881L181.284 166.368L184.972 134.603L154.543 133.715L152.584 120.837L151.914 116.448C151.914 116.448 157.744 116.892 165.166 117.788C172.483 118.676 181.347 119.988 187.717 121.76C187.725 121.76 187.725 121.76 187.725 121.76C190.591 122.554 192.951 123.442 194.439 124.412C202.609 129.755 183.784 185.769 183.784 185.769H183.792Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.282 166.372L184.97 134.607L154.541 133.719L152.582 120.841L165.168 117.788C172.485 118.676 181.349 119.988 187.719 121.76C187.42 121.76 180.145 121.892 175.126 125.382C175.126 125.382 184.441 128.092 190.142 133.711C193.896 137.415 186.645 154.907 181.278 166.372H181.282Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.232 73.4289C166.913 73.4523 171.738 73.5302 176.399 73.2303C178.343 73.0356 180.282 73.0512 181.89 71.9842C186.505 69.0362 190.676 65.3017 195.021 61.8982C195.804 61.2517 196.969 61.3685 197.603 62.1591C198.137 62.8211 198.125 63.744 197.638 64.3943C195.629 67.0619 193.511 69.5814 191.209 72.0114C188.654 74.5621 186.112 77.4127 182.685 78.9042C179.145 80.1776 175.659 80.3801 172.034 80.6332C168.665 80.8279 165.383 80.8669 162.01 80.7228C157.252 80.3801 157.462 73.4718 162.24 73.4289H162.232Z",
    fill: "#DB897C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.47 73.1875C167.128 72.5761 175.068 73.1875 175.068 73.1875L173.413 81.782L160.543 84.3366L161.466 73.1836L161.47 73.1875Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.061 73.1836L173.413 81.7781L164.601 83.5344L160.547 84.3405L160.999 78.8964L161.466 73.1836C167.128 72.5761 175.061 73.1836 175.061 73.1836Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.081 83.0399L160.547 84.3405L161.532 75.8005C163.612 76.7936 166.096 80.3568 167.081 83.0399Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.678 72.759L172.973 82.4634L174.791 81.9727L176.002 72.759H174.678Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.617 119.096C146.617 119.096 182.082 125.771 188.597 133.03C195.112 140.288 160.846 190.415 160.846 190.415L156.575 188.366L175.146 141.278L142.773 141.379L146.621 119.096H146.617Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.908 119.482C171.368 124.498 160.605 142.259 160.605 142.259C160.605 142.259 117.823 155.429 139.471 112.305L161.313 110.619L162.637 116.853C172.459 118.096 179.908 119.478 179.908 119.478V119.482Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.608 109.337L139.246 112.616L161.825 113.387L162.257 109.509L139.608 109.337Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.608 109.337L139.246 112.616L161.825 113.387L162.257 109.509L139.608 109.337Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.942 114.482L145.824 114.416L146.163 108.73L147.281 108.796L146.942 114.482Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.914 113.263L151.973 113.158L152.051 109.408L156.996 109.513L156.914 113.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.786 114.501L159.668 114.435L160.007 108.746L161.124 108.812L160.786 114.501Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.239 109.719L139.489 109.326C139.489 109.326 139.504 108.146 139.313 103.96C139.196 101.284 138.994 98.0637 138.659 94.6952C138.114 89.3679 137.238 83.6746 135.781 79.1924C135.781 79.1924 143.149 75.6175 161.467 73.1836C161.467 73.1836 165.732 84.9636 162.235 109.719H162.239Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.545 92.3665C156.518 92.7209 156.21 92.9857 155.856 92.9623C155.501 92.935 155.232 92.6274 155.26 92.273C155.287 91.9187 155.595 91.6539 155.949 91.6772C156.303 91.7045 156.568 92.0121 156.545 92.3665Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.622 99.3216C156.595 99.6759 156.288 99.9407 155.933 99.9174C155.579 99.8901 155.314 99.5825 155.337 99.2281C155.365 98.8737 155.672 98.6089 156.027 98.6323C156.381 98.6596 156.646 98.9672 156.622 99.3216Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.084 105.844C156.057 106.199 155.749 106.467 155.395 106.44C155.04 106.413 154.772 106.105 154.799 105.751C154.826 105.396 155.134 105.132 155.488 105.155C155.842 105.182 156.111 105.49 156.084 105.844Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.499 83.3122C143.499 83.3122 139.71 75.9522 149.313 74.2154C158.916 72.4785 161.377 78.3432 161.377 78.3432L156.739 77.1905L155.329 88.3708C155.329 88.3708 152.97 82.3776 146.011 79.3869L143.499 83.3083V83.3122Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.499 83.3122C143.499 83.3122 139.71 75.9522 149.313 74.2154C158.916 72.4785 161.377 78.3432 161.377 78.3432L156.739 77.1905L155.329 88.3708C155.329 88.3708 152.97 82.3776 146.011 79.3869L143.499 83.3083V83.3122Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.29 82.7476C149.807 80.341 145.609 76.8829 145.609 76.8829C147.973 74.9631 147.798 71.8555 147.373 69.8928C147.144 68.8102 146.836 68.0742 146.836 68.0742L153.261 69.7682C153.012 70.8313 152.872 71.7309 152.81 72.4941C152.736 73.3314 152.763 73.9973 152.845 74.523C153.145 76.5013 154.255 76.6103 154.255 76.6103C155.244 78.83 154.29 82.7476 154.29 82.7476Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.806 72.4941C152.732 73.3314 152.759 73.9973 152.841 74.523C150.278 73.9934 148.468 71.7815 147.369 69.8928C147.14 68.8102 146.832 68.0742 146.832 68.0742L153.257 69.7682C153.008 70.8313 152.868 71.7309 152.806 72.4941Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.133 185.952L176.056 186.715L177.255 185.788L179.163 189.694L186.893 196.104C186.893 196.104 189.148 195.886 186.282 191.852C186.153 191.669 186.033 191.458 185.928 191.221C184.728 188.674 184.514 183.245 184.514 183.245L180.273 179.729C180.273 179.729 179.95 179.819 179.42 180.052C178.182 180.601 175.76 181.898 175.137 185.952H175.133Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.418 180.052C179.414 180.06 179.406 180.064 179.406 180.064C180.485 179.904 180.758 184.76 181.852 187.241C182.829 189.453 184.399 191.373 185.929 191.221C184.73 188.674 184.975 182.093 184.975 182.093L181.564 179.266C181.564 179.266 179.948 179.819 179.418 180.052Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.137 190.154L151.857 191.112L153.24 190.489L154.186 194.733L160.214 202.767C160.214 202.767 162.457 203.082 160.611 198.487C160.53 198.277 160.459 198.047 160.413 197.79C159.84 195.033 160.892 189.706 160.892 189.706L157.586 185.298C157.586 185.298 157.251 185.309 156.678 185.414C155.346 185.66 152.687 186.357 151.141 190.154H151.137Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.672 185.411C156.664 185.414 156.66 185.422 156.66 185.422C157.747 185.516 156.882 190.306 157.369 192.969C157.805 195.349 158.884 197.58 160.406 197.786C159.834 195.029 161.602 188.686 161.602 188.686L158.942 185.142C158.942 185.142 157.24 185.305 156.672 185.411Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.32 62.6186L197.716 56.1426L202.829 59.9745C202.829 59.9745 201.092 64.8345 196.836 64.9552L194.32 62.6186Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.01 53.2063L205.137 56.9759L202.828 59.9744L197.711 56.1425L202.01 53.2063Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.657 113.387L157.943 113.991L156.404 120.195C156.404 120.195 151.252 120.487 149.484 116.616L150.657 113.387Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.322 116.803L160.071 121.152L156.406 120.194L157.944 113.991L162.322 116.803Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.049 119.217V121.339C193.049 121.885 192.406 122.107 191.869 122.107H149.453C148.908 122.107 148.254 121.885 148.254 121.339V119.217H193.053H193.049Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.049 119.217V121.339C193.049 121.885 192.406 122.107 191.869 122.107H149.453C148.908 122.107 148.254 121.885 148.254 121.339V119.217H193.053H193.049Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.047 119.217V121.339C193.047 121.885 192.404 122.107 191.867 122.107H163.891C163.346 122.107 162.699 121.885 162.699 121.339V119.217H193.047Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.145 97.1758L195.094 120.082C194.93 120.837 194.194 121.382 193.455 121.382H165.872C165.136 121.382 164.665 120.697 164.836 119.941L169.879 97.2109C170.05 96.4632 170.779 96.0894 171.518 96.0894H199.101C199.841 96.0894 200.308 96.4243 200.145 97.172V97.1758Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.145 97.1758L195.094 120.082C194.931 120.837 194.195 121.382 193.455 121.382H166.811C166.071 121.382 165.603 120.697 165.767 119.941L170.818 97.2109C170.981 96.4632 171.717 96.0894 172.457 96.0894H199.101C199.841 96.0894 200.309 96.4243 200.145 97.172V97.1758Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.545 108.82V108.827C186.545 110.79 184.442 112.383 182.9 112.383C181.358 112.383 180.446 110.79 180.883 108.827C181.323 106.904 182.857 105.338 184.364 105.28C183.924 107.239 184.866 108.827 186.401 108.827C186.432 108.827 186.541 108.827 186.541 108.82H186.545Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.31 103.959C139.194 101.284 138.991 98.0636 138.656 94.6951C140.004 92.4793 141.106 90.832 141.106 90.832C141.106 90.832 144.552 99.0021 139.307 103.959H139.31Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.471 85.0103C140.553 90.5712 140.319 99.0918 140.88 104.532L140.939 104.906C140.939 104.949 140.985 105.034 140.826 104.746C144.175 107.834 150.363 111.744 154.732 115.027C155.557 115.615 155.744 116.764 155.149 117.581C154.65 118.267 153.762 118.501 153.007 118.205C149.806 116.939 146.71 115.537 143.641 113.964C141.005 112.535 138.31 111.242 135.997 109.147C135.054 108.298 134.529 106.907 134.318 105.829C133.061 98.8776 133.123 91.9381 133.173 84.9246C133.427 80.1698 140.327 80.2399 140.471 85.0103Z",
    fill: "#DB897C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.785 79.1924C131.992 81.1239 131.384 87.6856 132.128 97.686L141.225 97.1018C141.225 97.1018 142.775 88.7955 141.529 84.9402C139.671 79.1885 135.785 79.1885 135.785 79.1885V79.1924Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.785 79.1924C131.992 81.1239 131.384 87.6856 132.128 97.686L141.225 97.1018C141.225 97.1018 142.775 88.7955 141.529 84.9402C139.671 79.1885 135.785 79.1885 135.785 79.1885V79.1924Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.488 97.1213L141.574 96.7903L141.356 98.2506L131.488 98.7724V97.1213Z",
    fill: "#AA7339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.742 52.0185C154.611 50.5115 155.919 53.7047 157.571 59.3397C159.635 66.3843 159.152 71.8089 151.873 71.7894C141.99 71.7622 138.524 54.0396 147.742 52.0146V52.0185Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.91 59.8071C153.91 59.8071 154.997 61.0922 156.029 61.762C156.029 61.762 155.717 62.6226 154.701 62.7083L153.91 59.8071Z",
    fill: "#DD5652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.414 60.0915C150.523 60.5471 150.367 60.9716 150.064 61.0456C149.76 61.1196 149.425 60.8119 149.316 60.3563C149.207 59.9007 149.363 59.4762 149.666 59.4022C149.97 59.3282 150.305 59.6398 150.414 60.0915Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.547 59.4566L150.443 58.8296C150.443 58.8296 150.15 59.7798 149.547 59.4566Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.031 58.6347C156.14 59.0903 155.985 59.5148 155.681 59.5888C155.377 59.6628 155.042 59.3552 154.933 58.8995C154.824 58.4439 154.98 58.0194 155.284 57.9454C155.587 57.8715 155.922 58.183 156.031 58.6347Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.168 57.9961L156.064 57.3691C156.064 57.3691 155.772 58.3193 155.168 57.9961Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.296 57.8754C147.261 57.8754 147.222 57.8676 147.187 57.8481C147.067 57.7858 147.02 57.6417 147.082 57.5249C147.756 56.1931 149.434 56.0373 149.504 56.0295C149.641 56.0295 149.754 56.1152 149.765 56.2476C149.777 56.38 149.68 56.4968 149.547 56.5085C149.532 56.5085 148.068 56.6526 147.515 57.7391C147.472 57.8248 147.386 57.8715 147.3 57.8715L147.296 57.8754Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.513 55.3987C153.431 55.3987 153.354 55.3598 153.307 55.2858C153.237 55.1728 153.268 55.0249 153.381 54.9548C153.424 54.9275 154.401 54.32 155.912 54.908C156.037 54.9548 156.099 55.095 156.048 55.2196C156.002 55.3442 155.857 55.4065 155.737 55.3559C154.471 54.8613 153.673 55.3403 153.642 55.3598C153.603 55.3831 153.56 55.3948 153.513 55.3948V55.3987Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.894 63.0041C143.894 63.0041 145.499 57.8755 144.342 54.4369C144.342 54.4369 147.372 49.5419 153.521 52.373C153.521 52.373 156.558 55.683 157.345 58.6037C157.345 58.6037 156.266 48.4476 146.667 50.3012C137.084 52.151 140.144 66.1156 145.982 69.2076C145.982 69.2076 142.909 66.2052 143.894 63.0041Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.055 63.9815C144.825 63.0937 143.571 61.7813 141.947 62.3226C140.265 62.8834 140.214 66.5985 144.681 66.5167C145.324 66.505 145.538 65.8313 145.055 63.9815Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.206 66.404C152.435 66.404 151.512 66.1508 150.787 65.1968C150.706 65.0916 150.729 64.9397 150.834 64.858C150.939 64.7762 151.091 64.7956 151.173 64.9047C152.454 66.5909 154.425 65.703 154.51 65.6641C154.631 65.6095 154.775 65.6602 154.83 65.7809C154.884 65.9016 154.834 66.0457 154.713 66.1002C154.701 66.1041 154.047 66.404 153.206 66.404Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.34 54.4369C144.34 54.4369 150.064 50.2272 155.08 53.0272C155.08 53.0272 155.656 47.77 149.659 47.3338C143.666 46.8977 139.18 53.7827 139.18 53.7827L144.336 54.4408L144.34 54.4369Z",
    fill: "#263138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.569 52.6922C146.569 52.6922 142.055 56.4501 143.173 63.8375C144.326 71.4468 143.286 74.9321 142.795 79.7998C142.141 86.2993 146.347 87.378 146.347 87.378C146.347 87.378 142.176 87.7869 140.833 83.1644C140.139 80.7851 140.548 70.9872 136.833 64.9668C132.612 58.1324 141.008 51.5707 146.573 52.6922H146.569Z",
    fill: "#263138"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_495_1942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284,
    height: 235.643,
    fill: "white",
    transform: "translate(0 0.178711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicingSendAlertSvg);
export default __webpack_public_path__ + "static/media/InvoicingSendAlertSVG.a038929106dbcf4b9761ed26ece4d726.svg";
export { ForwardRef as ReactComponent };